<template lang="pug">
  div
    .text-sm.font-semibold.mb-2 Collecting member
    search-member-dropdown.mt-2.mb-3(v-if="memberSelectable" v-model="selected" @change="handleChangeSelection")
    v-text-field.round-xl.mb-4(v-else-if="member" :value="member.name" dense height="48" outlined readonly hide-details)
    template(v-if="member")
      stamp-current-progress(v-if="loyaltySystem === 'stamps'" :stampCollected="valueCollected" :rewardsPosition="rewardsPosition")
      point-current-progress.mb-4(v-else :pointCollected="valueCollected" :availableRewards="member.available_rewards" show-current-progress-text)
      template(v-if="!isValueCollectable")
        .text-sm.danger500--text No more {{ loyaltySystem }} to collect
      template(v-else)
        .text-sm.font-semibold.mb-2 How many {{ loyaltySystem }} you would like to collect?
        template(v-if="loyaltySystem === 'stamps'")
          v-row.gap-2.justify-space-between.mb-4(no-gutters)
            v-col(:cols="2" v-for="stampNumber in 10" :key="stampNumber")
              template(v-if="stampNumber <= maxStampToCollect")
                v-card.round-xl.py-2.px-3(outlined :class="[{ 'border-selected': valueToCollect === stampNumber }]" @click="handleSelectStamp(stampNumber)")
                  .text-xs.text-center {{ stampNumber }} {{ stampNumber === 1 ? 'stamp' : 'stamps' }}
        template(v-else)
          v-text-field.round-xl.mb-4(:value="valueToCollect" outlined dense placeholder="0" hide-details="auto" suffix="points" @input="$emit('update:valueToCollect', parseInt($event))" type="number" :rules="rules.has_quantity" :loading="isFetching")
        .text-sm.font-semibold.mb-2 Purchased value
        v-text-field.round-xl.mb-4(:value="purchasedValue" outlined dense placeholder="Enter purchased value here" hide-details="auto" :prefix="$currency.symbol" @input="updatePurchasedValue($event)" type="number" :rules="rules.has_price")
</template>

<script>
import StampCurrentProgress from "@/components/clinic/checkout/marketing/collecting/stamps/StampCurrentProgress.vue";
import PointCurrentProgress from "@/components/clinic/checkout/marketing/collecting/points/PointCurrentProgress.vue";
import SearchMemberDropdown from "@/components/clinic/marketing/SearchMemberDropdown.vue";
import {mapGetters,mapActions} from "vuex";

export default {
  components: {
    SearchMemberDropdown, PointCurrentProgress, StampCurrentProgress,
  },
  props: {
    member: {
      type: Object,
      default: null
    },
    valueToCollect: {
      type: Number,
      default: null
    },
    purchasedValue: {
      type: String,
      default: null
    },
    valueCollected: {
      type: Number,
      default: 0
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    memberSelectable: {
      type: Boolean,
    }
  },
  data() {
    return {
      isFetching: false,
      pointsEarned: null,
      rules: {
        has_quantity: [v => !!v || 'This field is required', v => v > 0 || 'Should be more than 0'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || 'Amount should not be a negative number'],
      },
      selected: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.member) {
        this.selected = this.member
      }
    })
    this.fetchLoyaltySettings()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    maxStampToCollect() {
      return 10 - this.valueCollected
    },
    isValueCollectable() {
      if (this.loyaltySystem === 'stamps') {
        return this.maxStampToCollect > 0
      }
      return true
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLoyaltySettings () {
      if (this.loyaltySystem !== 'points') {
        return
      }
      this.isFetching = true
      let params = {
        fields: 'points_earned'
      }
      this.$axios.get(`/loyalty/${this.company.slug}`, { params })
        .then(resp => {
          this.pointsEarned = resp.data.points_earned
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    handleSelectStamp(stampNumber) {
      this.$emit('update:valueToCollect', stampNumber)
    },
    handleChangeSelection() {
      this.$emit('update:member', this.selected)
      if (this.loyaltySystem === 'stamps' && this.selected.collected === 10) {
        this.$emit('update:valueToCollect', null)
        return
      }
      this.$emit('update:valueToCollect', 1)
    },
    updatePurchasedValue(value) {
      this.$emit('update:purchasedValue', value)
      if (this.loyaltySystem === 'points') {
        let valueToCollect = Math.ceil(value * this.pointsEarned)
        this.$emit('update:valueToCollect', parseInt(valueToCollect))
      }
    },
  },
}
</script>

<style scoped>
.border-selected {
  border: 2px solid #333333 !important;
}

.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>